import { TemplateInfo } from '@mainstage/plugin-scaffolder-common';
import { Typography } from '@material-ui/core';
import { getTemplateTypeDisplayName } from '../../../template.utils';

export const TemplateTypeColumn = ({
  template,
}: {
  template?: TemplateInfo;
}) => {
  if (!template) {
    return null;
  }

  return (
    <Typography>
      {getTemplateTypeDisplayName((template.entity as any)?.kind ?? '')}
    </Typography>
  );
};
